export const listingManager = {
  header: {
    title: "Anuncios",
    newListingTitle: "Nuevo anuncio",
    reorderExit: "Salir del modo reordenar",
    reorder: "Reordenar anuncios",
    done: "Listo",
    sort: "Ordenar",
    searchPlaceholder: "Buscar…",
    searchClear: "Limpiar",
    reorderHint: "Arrastra para cambiar el orden",
  },
  globalBtn: {
    title: "Configuración global",
    sub: "Identidad y nuevas reservas · toda la cuenta",
  },
  list: {
    of: "de",
    listingSingular: "anuncio",
    listingPlural: "anuncios",
    unitSingular: "unidad",
    unitPlural: "unidades",
    retry: "Reintentar",
    noResults: 'Sin resultados para "{query}"',
    viewUnits: "Ver unidades",
    loadingUnits: "Cargando unidades…",
    refuerzaA: "Refuerza a {name}: ahora recoge sus reservas del canal",
    noUnits: "Sin unidades",
    dragToMove: "Arrastrar para mover",
    unitFallback: "Unidad {n}",
  },
  empty: {
    title: "Selecciona un anuncio",
    sub: "Elige un anuncio del panel izquierdo para gestionar su configuración.",
  },
  create: {
    title: "Nuevo anuncio",
    subtitle: "Crea un anuncio para agrupar tus unidades.",
    nameLabel: "Nombre del anuncio",
    namePlaceholder: "Ej: La puerta del sol",
    typeLabel: "Tipo de alojamiento",
    currencyLabel: "Moneda",
    currencyHint: "La moneda no se puede cambiar después de crear el anuncio.",
    submit: "Crear anuncio",
    nameRequired: "El nombre es requerido.",
    errorCreate: "Error al crear el anuncio.",
    successCreate: "Anuncio creado correctamente.",
  },
  delete: {
    titleListing: "Eliminar anuncio",
    titleUnit: "Eliminar unidad",
    text: "Se eliminará de WACheckin. Estos cambios no se pueden revertir. Para confirmar, escribe el nombre:",
    placeholderListing: "Nombre del anuncio",
    placeholderUnit: "Nombre de la unidad",
    deleting: "Eliminando…",
    confirm: "Eliminar",
    errorDelete: "No se pudo eliminar.",
    successListing: "Anuncio eliminado correctamente.",
    successUnit: "Unidad eliminada correctamente.",
  },
  propertyTypes: {
    apartment: "Apartamento",
    villa: "Villa",
    hotel: "Hotel",
    camping: "Camping",
  },
  propertyTypeLabels: {
    apartment: "Apartamento",
    house: "Casa",
    villa: "Villa",
    hotel: "Hotel",
    room: "Habitación",
    studio: "Estudio",
    fallback: "Alojamiento",
  },
  toast: {
    errorLoad: "Error al cargar los anuncios.",
    orderSaved: "Orden guardado correctamente.",
    errorOrder: "No se pudo guardar el orden.",
    nameUpdated: "Nombre actualizado.",
    errorName: "No se pudo actualizar el nombre.",
  },
  common: {
    cancel: "Cancelar",
  },
  globalConfig: {
    hero: {
      title: "Configuración global",
      subPre: "Ajustes del Agente IA que se aplican a",
      subStrong: "todos tus alojamientos",
      subPost: ".",
    },
    waba: {
      checking: "Comprobando conexión…",
      connected: "Conectado",
      start: "Empieza por aquí",
      titleConnected: "WhatsApp Business",
      titleDisconnected: "Conectar WhatsApp Business",
      checkingSub: "Comprobando el estado de tu número…",
      numberPrefix: "Número",
      verified: "verificado y listo para enviar ✓",
      pending: "pendiente de verificación",
      linked: "Tu cuenta de WhatsApp Business está vinculada.",
      linkPrompt: "Vincula tu número para que el agente atienda y envíe mensajes a tus huéspedes por WhatsApp.",
      manage: "Gestionar",
      connect: "Conectar",
    },
    sectionLabel: "General · toda la cuenta",
    badgeDefault: "IA ✨",
    requiresWaba: "Requiere WhatsApp Business conectado",
    notContracted: "No incluido en tu plan. Escríbenos para activarlo.",
    cards: {
      general: {
        title: "Configuración General",
        sub: "Identidad y estilo del agente",
      },
      newBookings: {
        title: "Nuevas Reservas",
        sub: "Primer contacto, dudas y enlace de reserva",
      },
      voiceAgent: {
        title: "Agente IA de Voz",
        sub: "Atiende llamadas por teléfono",
        badge: "NUEVO",
      },
    },
    foot: {
      pre: "Estos ajustes son",
      strong: "únicos para tu cuenta",
      post: ": al cambiarlos aquí, se aplican automáticamente a todos los anuncios. El resto de la configuración (check-in, accesos, precios…) sigue siendo de cada anuncio.",
    },
  },
};
